//I Would Highly Recommend You To Customize The Theme According To Your Taste.
// import pp from "../src/images/pp.jpg";
// import resume from "../src/Resume/resume.pdf";
export const globalStyles = {
  "--grad": "linear-gradient(315deg,#48a9fe,#00cdac)", // Use gradients only
  // "--grad": "linear-gradient(315deg, #48a9fe 0%, #734ae8 74%)", // Use gradients only
  // "--grad": "linear-gradient(315deg, #06bcfb 0%, #4884ee 74%)",
  "--txtcolor": "#272341",
  "--p_color": "#00cdac",
  "--s_color": "#fff",
};

// Navigation Bar Name
export const navbar_name = "<Danish>";

// Main Page
export const main = {
  name: "Danish Ahmed",
  doamin: "A MERN Stack Web Developer",
  resume:
    "https://drive.google.com/file/d/17Vb2EK6LhtXxrxaPtqe4OfAOB7aUz64s/view?usp=sharing",
};

// AboutMe
export const aboutme = {
  imgLink: "https://avatars.githubusercontent.com/u/95852994?v=4",
  p1: "Hey, My name is Danish Ahmed. I have completed my Bachelor of Engineering from North Maharashtra University, Jalgaon (Maharashtra).",
  p2: " I'm a passionate coder and an enthusiastic Web Developer capable of applying programming skills to solve complex problems. Seeking a challenging role in the field of software development that will offer an opportunity for further development of my abilities, skills and knowledge in an organization.",
  // p3: "Apart from coding I also like photography 📸, cooking 👨‍🍳 and riding 🏍️.",
};

// Skills
export const whatido = {
  title: "Full Stack Development",

  details: [
    "Building responsive website using HTML,CSS,JS,React",
    "Creating backend application in Node, ExpressJS",
    "Building Simple RESTful CRUD APIs",
    "Knowledge of MongoDB Database",
    "Knowledge of various UI libraries",
  ],
  logos: [
    {
      name: "HTML5",
      iconifyClassName: "vscode-icons:file-type-html", // PS : Use iconify class name
      id: "1",
    },
    {
      name: "CSS",
      iconifyClassName: "vscode-icons:file-type-css",
      id: "2",
    },
    {
      name: "JavaScript",
      iconifyClassName: "logos:javascript",
      id: "3",
    },
    {
      name: "ReactJS",
      iconifyClassName: "vscode-icons:file-type-reactjs",
      id: "4",
    },
    {
      name: "Redux",
      iconifyClassName: "logos:redux",
      id: "5",
    },
    {
      name: "NodeJS",
      iconifyClassName: "logos:nodejs",
      id: "6",
    },
    {
      name: "ExpressJS",
      iconifyClassName: "logos:express",
      id: "7",
    },
    {
      name: "MongoDB",
      iconifyClassName: "logos:mongodb",
      id: "8",
    },

    {
      name: "Tailwind",
      iconifyClassName: "logos:tailwindcss-icon",
      id: "12",
    },
    {
      name: "Material-UI",
      iconifyClassName: "logos:material-ui",
      id: "13",
    },
    // {
    //   name: "Ant Design",
    //   iconifyClassName: "logos:ant-design",
    //   id: "14",
    // },

    {
      name: "Bootstrap",
      iconifyClassName: "logos:bootstrap",
      id: "17",
    },
    {
      name: "Postman",
      iconifyClassName: "logos:postman-icon",
      id: "9",
    },
    {
      name: "npm",
      iconifyClassName: "logos:npm-icon",
      id: "10",
    },
    {
      name: "GIT",
      iconifyClassName: "logos:git",
      id: "11",
    },
    {
      name: "Vercel",
      iconifyClassName: "logos:vercel-icon",
      id: "16",
    },
    {
      name: "Netlify",
      iconifyClassName: "vscode-icons:file-type-netlify",
      id: "15",
    },
  ],
};

// Project Details
export const details = [
  {
    id: 1,
    title: "Flat Manager App",
    desc: `An app where flat manager can manage flats and their owners details.`,
    feature:
      "User authentication, Social Sign-in/Sign-up, Add flats, Pagination, Flat Sorting/Filtering..",

    tech: `Tech Stack: HTML | CSS | React | Heroku | NodeJS | Express | MongoDB`,
    img: "https://github.com/danish4git/Apartment-Manager-frontend/blob/master/public/Screenshot%20(1868).png?raw=true",
    link: "https://apartment-manager-frontend-alpha.vercel.app/",
    github: "https://github.com/danish4git/Apartment-Manager-frontend.git",
  },
  {
    id: 2,
    title: "Movie App",
    desc: `A Movie App where we can search movies and can filter movies.`,
    feature: "Search Movies, Filter Movies.",

    tech: `Tech Stack: HTML | CSS | React`,
    img: "https://github.com/danish4git/react-movie-app/blob/master/public/Screenshot%20(1840).png?raw=true",
    link: "https://react-movie-app-omega.vercel.app/",
    github: "https://github.com/danish4git/react-movie-app.git",
  },
  {
    id: 3,
    title: "revv.co.in clone",
    desc: `A web application to rent four-wheelers on a daily basis.`,
    feature: `Location-based vehicle gallery,
    User authentication,
    Vehicle selection page,
    Product Sorting/Filtering.`,
    tech: `Tech Stack: HTML | CSS | JavaScript | Bootstrap | MongoDB | Express | Heroku`,
    img: "https://github.com/danish4git/revv2.0/blob/master/images/Screenshot%20(1728).png?raw=true",
    link: "https://revv2-0-7vnfei08y-danish4git.vercel.app/",
    github: "https://github.com/danish4git/revv2.0",
  },
  {
    id: 4,
    title: "us.shein.com clone",
    desc: `It is an E-Commerce website where user can purchase
    fashion-related products..`,
    feature: `Social Sign-in/Sign-up,
    Product selection,
    Add to cart,
    Payment Page,
    User authentication.`,
    tech: `Tech Stack: HTML | CSS | JavaScript | Bootstrap`,
    img: "https://miro.medium.com/max/963/1*BLyIlkxbuznhxtyNobFvag.png",
    link: "https://shein-clone-2gxm7ioze-danish4git.vercel.app/",
    github: "https://github.com/danish4git/Shein-clone",
  },

  // {
  //   id: 9,
  //   title: "unacademy clone",
  //   desc: `Unacademy is an Indian educational technology company, based in Bangalore. Originally created as a YouTube channel in 2010 by Gaurav Munjal, the company was founded in 2015 by Gaurav Munjal, Roman Saini, and Hemesh Singh.`,
  //   feature: `Education platform where students can subscribe and access live and recorded classes.`,

  //   tech: `Tech Stack: HTML | CSS | React | Redux | MongoDB | Express | NodeJS `,
  //   img: "https://raw.githubusercontent.com/monumishra326/Monu-portfolio/main/Screenshot%20(68).png",
  //   link: "https://unacdemy.vercel.app/",
  //   github: "https://github.com/monumishra326/unacdemy-clone.git",
  // },
];

// Social Media Links
export const links = [
  // "https://www.instagram.com/danish4insta/",
  "https://www.linkedin.com/in/danish-ahmed-9b12b7158/",
  "https://api.whatsapp.com/send/?phone=918600156397&text&app_absent=0",
  "mailto:danish4eng@gmail.com",
  "https://medium.com/@danish4eng",
  "https://github.com/danish4git",
];
